const blogSections = document.querySelectorAll('.blog-details-content section');
const allH2Tags = document.querySelectorAll('.blog-details-content section h2');
const toc = document.querySelector('.table-of-content');
const toc_wrap = document.querySelector('.table-of-content-wrap');
const toc_col = document.getElementById('table-of-content-col');
const toc_links = []

count = 1;
blogSections.forEach(section => {
    let subLinks = document.createElement('div');
    for (const key in section.childNodes) {
        if (Object.hasOwnProperty.call(section.childNodes, key)) {
            let childNode = section.childNodes[key].nodeName;

            if (childNode === 'H2') {
                let heading = section.childNodes[key].textContent;
                let transformedHeading = trasnformText(heading);

                section.setAttribute('id', transformedHeading);
                toc_links.push(createLinkNode(heading, transformedHeading, 'toc-link', toc))
            }
            if (childNode === 'H3') {
                let subHeading = section.childNodes[key].textContent;
                let transformedSubHeading = trasnformText(subHeading);
                subLinks.classList.add('toc-sublinks');
                toc.appendChild(subLinks);
                section.childNodes[key].setAttribute('id', `${section.id}-${transformedSubHeading}`);
                toc_links.push(createLinkNode(subHeading, `${section.id}-${transformedSubHeading}`, 'toc-sublink', subLinks))
            }
        }
    count += 1;
    }
});


function trasnformText(text) {
    return text.replaceAll(/[-+_.:?/]/g, "").toLowerCase().trim().split(" ").join("-");
}

function createLinkNode(linkText, linkURL, className, groupElement) {
    let link = document.createElement('span');
    link.innerText = linkText.replaceAll(/[:?]/g, "");
    // link.setAttribute('href', `#${linkURL}`);
    link.setAttribute('data-id', `${linkURL}`);
    link.classList.add(className);
    groupElement.appendChild(link);
    return link
}

if (document.querySelector('body.template-article')) {
  window.addEventListener('scroll', () => {
    const contentTop = document.querySelector("#blog-content-col").getBoundingClientRect().top + document.documentElement.scrollTop;
    const contentBottom = document.querySelector("#blog-content-col").getBoundingClientRect().bottom + document.documentElement.scrollTop;
    if(window.matchMedia("(min-width: 769px)").matches && window.scrollY > contentTop - 50) {
      // toc.style.position = "fixed";
      // toc.style.top = "50px";
      // toc.style.width = `calc(${toc_wrap.getBoundingClientRect().width}px - 20px)`;
      // let sticky_toc_bottom = toc.getBoundingClientRect().bottom + document.documentElement.scrollTop + 50 
      // if(sticky_toc_bottom >= contentBottom) {
      //   toc.style.position = "static";
      //   toc.style.marginBottom = '50px';
      //   toc_col.style.justifyContent = 'flex-end';
      // }
      
      for(let i=0; i<toc_links.length; i++) {
        if(window.scrollY >= document.getElementById(toc_links[i].getAttribute('data-id')).getBoundingClientRect().top + document.documentElement.scrollTop -50) {
          if (i !== 0) toc_links[i-1].classList.remove('active')
          toc_links[i].classList.add('active')
        } 
        else {
          toc_links[i].classList.remove('active')
        }
      }
      
    }
    // else {
    //   if(window.matchMedia("(min-width: 769px)").matches) toc.style.width = "calc(100% - 20px)";
    //   else toc.style.width = "100%"
    //   toc.style.position = "static";
    //   toc_col.style.justifyContent = 'flex-start';
    // }
  });
  for(let i=0; i<toc_links.length; i++) {
    toc_links[i].addEventListener('click', (e) => {
      document.getElementById(`${toc_links[i].getAttribute('data-id')}`).scrollIntoView();
    })
  }
}